export default (payload) => ({
  type: 'SET_FORM_MODAL',
  payload,
});
